<div class="checkout-card" *ngIf="metadadosGreen">
    <!-- IMAGEM -->
    <div class="image-wrapper">
        <img [src]="metadadosGreen['og:image']" alt="Produto" loading="lazy" />
        <span class="secure-badge">Pagamento seguro</span>
    </div>

    <!-- CONTEÚDO -->
    <div class="content">
        <span class="context-label">Próximo teste</span>
        <h3>{{ metadadosGreen['og:title'] }}</h3>

        <p>
            {{ metadadosGreen['og:description'] }}
        </p>
    </div>

    <!-- FOOTER -->
    <div class="card-footer">
        <button (click)="irParaCheckout()">
            Obtenha o acesso →
        </button>
    </div>
</div>


<div class="checkout-card skeleton" *ngIf="!metadadosGreen">
    <div class="card-header">
        <div class="skeleton-badge"></div>
        <div class="skeleton-title"></div>
    </div>

    <div class="checkout-preview">
        <div class="skeleton-preview"></div>
    </div>

    <div class="card-footer">
        <div class="skeleton-button"></div>
    </div>
</div>
